import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { UsersBase } from './Users'

import { modalActions } from 'reduxModules/actions/ModalActions'
import { usersSelector, isPrexBusSelector } from 'reduxModules/selectors/UserSelectors'
import { userActions } from 'reduxModules/actions/UserActions'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  users: usersSelector,
  isPrexBus: isPrexBusSelector
})

const mapDispatchToProps = {
  getUsers: userActions.getUsers,
  showModal: modalActions.showModal,
  deleteUser: userActions.deleteUser,
  setUserLineId: userActions.setUserLineId,
  resetUserPassword: userActions.resetUserPassword,
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const Users = enhance(UsersBase)



// WEBPACK FOOTER //
// ./src/components/Users/index.js